

























































































































































import {API} from '@/services/api/api';
import {Vue, Component, Watch} from 'vue-property-decorator';
import {mapGetters, mapActions} from 'vuex';
import FilterMenu from '@/components/FilterMenu.vue';
import InsapectionList from '@/components/InspectionListComponent.vue';
import ShipList from '@/models/shiplist';
import HtmlToPdfComponent from '@/components/template/HtmlToPdfComponent.vue';
import PDFTemplate from '@/components/template/PDFTemplate.vue';
import canvasMerge from '@/utils/CanvasMerge';
import {getImage, Utils} from '@/utils/Utils';
@Component({
  components: {
    FilterMenu,
    InsapectionList,
    HtmlToPdfComponent,
    PDFTemplate,
  },
  computed: {
    ...mapGetters(['shipList']),
    getDeckDetails() {
      return {
        deckName: this.deckName,
        deckImage: this.createdDeckImageUrl || this.deckImageUrl,
      };
    },
    getShipDetails() {
      return {
        shipName: this.shipNameForPrint,
        dateFrom: this.dateFrom,
        dateUpto: this.dateUpto,
        shipImage: this.createdShipImage || this.shipImageUrl,
      };
    },
  },
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
  watch: {
    $route(to, from) {
      this.shipId = Number(to.params.shipId);
      this.onShipChange();
    },
  },
})
export default class InspectionListPage extends Vue {
  showErrorToast: any;
  shipImgLoader: Boolean = false;
  deckImgLoader: Boolean = false;
  showSuccessToast: any;
  shipId: number = null;
  dateFrom = null;
  dateUpto = null;
  inspectionList = [];
  shipDots = [];
  deckDots = [];
  shipImageUrl = '';
  createdShipImage = '';
  createdDeckImageUrl = '';
  shipName = '';
  shipList: any;
  deckImageUrl = '';
  deckName = '';
  isScreenLoading = false;
  deckId: number = null;
  printBtnLoader = false;
  howercontectText: String = '';
  shipNameForPrint = '';
  shipDetails = {
    shipName: this.shipName,
    dateFrom: this.dateFrom,
    dateUpto: this.dateUpto,
    shipImage: this.createdShipImage || this.shipImageUrl,
  };

  deckDetails = {
    deckName: this.deckName,
    deckImage: this.createdDeckImageUrl || this.deckImageUrl,
  };

  mounted() {
    if (this.$route.params.shipId) {
      this.shipId = Number(this.$route.params.shipId);
      this.onShipChange();
    }
  }

  async getInspectionList() {
    try {
      this.inspectionList = [];
      this.isScreenLoading = true;
      const param = {
        ShipId: this.shipId,
        DeckId: this.deckId,
        // ShipId: null,

        FromDate: this.dateFrom,
        EndDate: this.dateUpto,
      };
      const response = await API.getInspectionListByShip(param);
      if (response.data) {
        this.inspectionList = response.data;
        // this.renderDot;

        //
      } else if (response.errors) {
        if (response.errors.ShipId) {
          this.showErrorToast({msg: response.errors.ShipId[0]});
        } else if (response.errors.InspectionId) {
          this.showErrorToast({msg: response.errors.InspectionId[0]});
        } else if (response.errors.FromDate) {
          this.showErrorToast({msg: response.errors.FromDate[0]});
        } else if (response.errors.ToDate) {
          this.showErrorToast({msg: response.errors.ToDate[0]});
        }
      } else {
        this.showErrorToast({msg: 'Network error'});
      }
      //
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  async onShipChange() {
    this.deckId = null;
    this.shipImageUrl = '';
    this.createdDeckImageUrl = '';

    const index = this.shipList.findIndex((ship) => ship.shipId === this.shipId);
    this.shipName = this.shipList[index].fileName;
    this.shipNameForPrint = this.shipList[index].name;
    this.shipImageUrl = await getImage(this.shipList[index].imagePath);
    this.createdShipImage = '';
    this.shipImgLoader = true;
    await this.getInspectionList();
  }

  async onDownLoadShipClick() {
    const data = await Utils.downloadImage(this.createdShipImage || this.shipImageUrl, this.shipName);

    data.click();
  }

  async onDownLoadDeckClick() {
    const data = await Utils.downloadImage(this.createdDeckImageUrl || this.deckImageUrl, this.deckName);

    data.click();
  }
  async onShipClick(e) {
    let imageRef = this.$refs.shipImageRef as HTMLImageElement;

    let offset = imageRef.getBoundingClientRect();
    let x = e.clientX - offset.left;
    let y = e.clientY - offset.top;
    let cw = imageRef.clientWidth;
    let ch = imageRef.clientHeight;
    let iw = imageRef.naturalWidth;
    let ih = imageRef.naturalHeight;
    let posx = (x / cw) * iw;
    let posy = (y / ch) * ih;

    let detactMouse = false;
    this.shipDots.map((dots) => {
      if (Utils.mouseDistance(dots.x, dots.y, posx, posy) < 0.003 * imageRef.naturalWidth) {
        this.$router.push(`/view-inspection/` + dots.inspectionID);
        detactMouse = true;
      }
    });

    if (!detactMouse) {
      const ship = this.shipList.find((me) => {
        return me.shipId === this.shipId;
      });
      //

      const decks = ship.drawing;

      const deck = decks.find((d) => d.topY <= posy && posy <= d.bottomY);
      if (deck) {
        this.deckName = deck.fileName;
        this.deckImageUrl = await getImage(deck.imagePath);
        this.createdDeckImageUrl = '';
        this.deckId = deck.drawingId;
        this.getInspectionList();
      }
    }
  }
  async onDeckClick(e) {
    let imageRef = this.$refs.deckImageRef as HTMLImageElement;
    let offset = imageRef.getBoundingClientRect();
    let x = e.clientX - offset.left;
    let y = e.clientY - offset.top;
    let cw = imageRef.clientWidth;
    let ch = imageRef.clientHeight;
    let iw = imageRef.naturalWidth;
    let ih = imageRef.naturalHeight;
    let posx = (x / cw) * iw;
    let posy = (y / ch) * ih;
    this.deckDots.map((dots) => {
      if (Utils.mouseDistance(dots.x, dots.y, posx, posy) < 0.003 * imageRef.naturalWidth) {
        this.$router.push(`/view-inspection/` + dots.inspectionID);
      }
    });
  }
  onPrintClick() {
    this.printBtnLoader = true;
    this.shipDetails = {
      shipName: this.shipNameForPrint,
      dateFrom: this.dateFrom,
      dateUpto: this.dateUpto,
      shipImage: this.shipImageUrl,
    };

    this.deckDetails = {
      deckName: this.deckName,
      deckImage: this.deckImageUrl,
    };

    const ref: any = this.$refs.pdfTemplateRef;
    ref.htmlToPdf();
  }

  stopBtnLoader() {
    this.printBtnLoader = false;
  }

  //make a copy of zone lines and orignal image
  mergeImage(type = 1) {
    let img;
    let dots;
    if (type == 2) {
      img = this.deckImageUrl;
      dots = this.deckDots;
    } else {
      img = this.shipImageUrl;
      dots = this.shipDots;
    }

    canvasMerge(img, dots, {
      crossOrigin: 'anonymous',
      drawType: 'circle',
    }).then((b64) => {
      if (type == 2) {
        this.createdDeckImageUrl = b64;
      } else {
        this.createdShipImage = b64;
      }

      // this.initDriftZoom();
    });
  }

  renderDot() {
    this.shipDots = [];
    if (!this.shipImgLoader && this.shipImageUrl && this.inspectionList.length > 0) {
      let imageRef = this.$refs.shipImageRef as HTMLImageElement;
      this.inspectionList.map((inspection) => {
        const points = inspection.additionalInfo;
        let deckWidth = inspection.deckImageWidth;
        let deckHeight = inspection.deckImageHeight;
        let shipHeight = inspection.shipImageHeight;
        let shipWidth = inspection.shipImageWidth;
        let y = null;
        let framePosition = null;
        if (inspection.isMisc) {
          y = (points.deckTopY + points.deckBottomY) / 2;
          let totalFrame = points.frameUpto - points.frameFrom;
          let pixelsCountInZone = points.zoneEndPoint - points.zoneStartPoint;
          let pixelsInEachframes = pixelsCountInZone / totalFrame;
          let thisframePosition = points.frameUpto - inspection.frameNumber;
          framePosition = points.zoneStartPoint + thisframePosition * pixelsInEachframes;
        } else {
          y = (points.deckTopY + points.deckBottomY) / 2;
          framePosition = points.location_X;
        }

        let widthPoint = (shipWidth / deckWidth) * framePosition;
        let heightPoint = y;

        this.shipDots.push({
          x: widthPoint,
          y: heightPoint,
          radius: 0.003 * imageRef.naturalWidth,
          color: Utils.getBackgroundColor(inspection.severity),
          inspectionID: inspection.inspectionID,
          inspectionCode: inspection.inspectionCode,
        });
      });
      this.mergeImage(1);
    }
  }
  renderDotDeck() {
    this.deckDots = [];

    if (!this.deckImgLoader && this.deckImageUrl && this.inspectionList.length > 0) {
      let imageRef = this.$refs.deckImageRef as HTMLImageElement;
      this.inspectionList.map((inspection) => {
        const points = inspection.additionalInfo;

        let x,
          y = null;
        if (inspection.isMisc) {
          y = (points.centerFrom + points.centerUpto) / 2;
          let totalFrame = points.frameUpto - points.frameFrom;
          let pixelsCountInZone = points.zoneEndPoint - points.zoneStartPoint;
          let pixelsInEachframes = pixelsCountInZone / totalFrame;
          let thisframePosition = points.frameUpto - inspection.frameNumber;
          let framePosition = points.zoneStartPoint + thisframePosition * pixelsInEachframes;
          x = framePosition;
        } else {
          y = points.location_Y;
          x = points.location_X;
        }

        this.deckDots.push({
          x: x,
          y: y,
          radius: 0.003 * imageRef.naturalWidth,
          color: Utils.getBackgroundColor(inspection.severity),
          inspectionID: inspection.inspectionID,
          inspectionCode: inspection.inspectionCode,
        });
      });
      this.mergeImage(2);
    }
  }

  shipImageLoad() {
    let _this = this;
    this.shipImgLoader = false;
    this.renderDot();
    window.onmousemove = function (e) {
      const main = e.target as HTMLImageElement;
      if (main.classList.contains('shipimg')) {
        //	Content of dot which is hovered
        const $target = main.nextElementSibling as HTMLElement;
        //

        //	Only work with hovered target
        //	Add visible class hovered elem to distinguish
        if (!$target.classList.contains('visible')) {
          $target.classList.add('visible');
        } else {
          //	Get viewport offset of tooltip element
          let offset = $target.parentElement.getBoundingClientRect();
          //	Tooltip distance from mouse(px)
          let tipDist = 15;
          //	Calc and set new tooltip location
          $target.style.top = e.clientY - offset.top + tipDist + 'px';
          $target.style.left = e.clientX - offset.left + tipDist + 'px';

          offset = main.getBoundingClientRect();
          let x = e.clientX - offset.left;
          let y = e.clientY - offset.top;
          let cw = main.clientWidth;
          let ch = main.clientHeight;
          let iw = main.naturalWidth;
          let ih = main.naturalHeight;
          let posx = (x / cw) * iw;
          let posy = (y / ch) * ih;

          let detactMouse = false;
          _this.shipDots.map((dots) => {
            if (Utils.mouseDistance(dots.x, dots.y, posx, posy) < 0.003 * main.naturalWidth) {
              //
              _this.howercontectText =
                'Click here to view inspection : ' + dots.inspectionCode + ' (ID: ' + dots.inspectionID + ')';
              main.style.cursor = 'pointer';
              detactMouse = true;
            }
          });

          if (!detactMouse) {
            const ship = _this.shipList.find((me) => {
              return me.shipId === _this.shipId;
            });

            const decks = ship.drawing;

            const deck = decks?.find((d) => d.topY <= posy && posy <= d.bottomY);
            if (deck) {
              _this.howercontectText = 'Click here to view inspection of deck: ' + deck.name;
              main.style.cursor = 'unset';
            } else {
              _this.howercontectText = '';
              main.style.cursor = 'unset';
            }
          }
        }
      } else if (main.classList.contains('deckimg')) {
        //	Content of dot which is hovered
        let imageRef = _this.$refs.deckImageRef as HTMLImageElement;
        let offset = imageRef.getBoundingClientRect();
        let x = e.clientX - offset.left;
        let y = e.clientY - offset.top;
        let cw = main.clientWidth;
        let ch = main.clientHeight;
        let iw = main.naturalWidth;
        let ih = main.naturalHeight;
        let posx = (x / cw) * iw;
        let posy = (y / ch) * ih;

        let detactMouse = false;
        _this.deckDots.map((dots) => {
          if (Utils.mouseDistance(dots.x, dots.y, posx, posy) < 0.005 * main.naturalWidth) {
            //
            _this.howercontectText =
              'Click here to view inspection : ' + dots.inspectionCode + ' (ID: ' + dots.inspectionID + ')';
            main.style.cursor = 'pointer';
            detactMouse = true;
          }
        });
        if (!detactMouse) {
          main.style.cursor = 'unset';
          _this.howercontectText = '';
        }
      } else {
        //	Remove visible class
        var content = document.getElementsByClassName('hovercontent');
        for (var i = 0; i < content.length; i++) {
          content[i].classList.remove('visible');
        }
      }
    };
  }
  deckImageLoad() {
    this.deckImgLoader = false;
    this.renderDotDeck();
  }

  @Watch('shipList', {immediate: true})
  shipListLoaded() {
    if (this.shipList?.length < 1 || this.shipList === undefined) {
      this.showErrorToast({
        msg: 'Permissions have not been assigned to this user properly. Please assign permissions.',
      });
    }
  }
}
